/**
 * Service for opening the task editing modal
 * @author Brendan Magee
 */

import taskModal from '../components/task-modal/taskModal.html';

function TaskModalController($scope, $uibModalInstance, task) {
  $scope.task = task;

  $scope.$on('task-updated', ($event, payload) => {
    $uibModalInstance.close(payload.task);
  });

  $scope.$on('task-created', ($event, payload) => {
    $event.stopPropagation();
    $uibModalInstance.close(payload.task);
  });
}

function taskModalService($uibModal, featureFlag) {
  const service = {};
  let modalConfig = {
    template: taskModal,
    controller: ['$scope', '$uibModalInstance', 'task', TaskModalController]
  };
  featureFlag.isEnabled('tasksv2').then((enabled) => {
    if (enabled) modalConfig = { component: 'taskModalv2', size: 'lg' };
  });

  service.saveTask = (
    positiveCallback,
    task = {},
    negativeCallback = angular.noop
  ) => {
    $uibModal
      .open(
        Object.assign(
          {
            resolve: {
              task() {
                return task;
              }
            }
          },
          modalConfig
        )
      )
      .result.then(positiveCallback, negativeCallback);
  };

  return service;
}

const serviceArray = ['$uibModal', 'featureFlag', taskModalService];

export default function (ngModule) {
  ngModule.factory('taskModalService', serviceArray);
}
